import { useMemo } from "react";

export const useParticipants = (companies, participants, roles: String[]) => useMemo(() => {
    const resultMap = new Map<string, { companyId: Number, name: string }>();
    resultMap.set('0', { companyId: 0, name: '' });
    for (let participant of participants.models) {
        for (let role of roles) {
        if (participant.role === role) {
            if (!resultMap.has(participant.companyId)) {
                const company = companies.models.filter(c => c.id === participant.companyId);
                if (company.length > 0) {
                    resultMap.set(participant.companyId, { companyId: participant.companyId, name: company[ 0 ].name });
                }
            }
        }
        }
    }
    return Array.from(resultMap.entries())
        .map(([ id, participant ]) => ({ id, companyId: participant.companyId, name: participant.name }))
        .sort((a, b) => a.name.localeCompare(b.name)) as any;
}, [ companies[ '_changeToken' ], participants[ '_changeToken' ] ]);
